

export default {
  SET_LIST_ITEM_IN_CART(state, payload) {
    state.listItemInCart = payload
  },
  SET_ADDRESS_USER(state, payload) {
    state.addressUser = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/cart/mutations.js